<div class="integration-card" [attr.data-testid]="'integration-card-' + vendor.vendor">
    <!-- Banner -->
    <div class="integration-card__banner" [style.background-color]="vendor.bannerBgColor">
        <!-- Status badge at a fixed position: badgeKey override first, else action (orange) before connected. -->
        <span
            *ngIf="badgeKey != null"
            class="integration-card__badge"
            [class.integration-card__badge--connected]="badgeVariant === 'connected'"
            [class.integration-card__badge--action]="badgeVariant === 'action'"
            [class.integration-card__badge--danger]="badgeVariant === 'danger'"
            [attr.data-testid]="'integration-card-badge-' + badgeVariant"
        >
            {{ badgeKey | i18next }}
        </span>
        <span
            *ngIf="badgeKey == null && needsAction"
            class="integration-card__badge integration-card__badge--action"
            data-testid="integration-card-badge-action"
        >
            {{ 'aumico_integration_card_status_action_required' | i18next }}
        </span>
        <span
            *ngIf="badgeKey == null && !needsAction && connected"
            class="integration-card__badge integration-card__badge--connected"
            data-testid="integration-card-badge-connected"
        >
            {{ 'aumico_integration_card_status_connected' | i18next }}
        </span>

        <img [src]="vendor.logoSrc" [alt]="vendor.displayNameRaw ?? ((vendor.displayNameKey ?? '') | i18next)" class="integration-card__logo" />
    </div>

    <!-- Body -->
    <div class="integration-card__body">
        <div class="integration-card__text">
            <p class="integration-card__name">
                <span>{{ vendor.displayNameRaw ?? ((vendor.displayNameKey ?? '') | i18next) }}</span>
                <span
                    *ngIf="beta"
                    class="integration-card__beta"
                    data-testid="integration-card-beta"
                    [hamTooltip]="'aumico_integration_card_beta_tooltip' | i18next"
                    [multiline]="true"
                    tooltipMaxWidth="280px"
                    >{{ 'aumico_integration_card_beta' | i18next }}</span
                >
            </p>
            <p class="integration-card__desc">{{ vendor.descriptionKey | i18next }}</p>
        </div>

        <!-- The single universal action. All state-based actions live in the modal. -->
        <ham-button variant="secondary" size="sm" (buttonClick)="onInfo()">
            {{ 'aumico_integration_card_btn_info' | i18next }}
        </ham-button>
    </div>
</div>
